Vue.filter('isShowAddToBasketCheck', function (properties, customerClass) {
  if (!properties) {
    return true;
  }
  let result = true;
  properties.forEach(function (props) {
    if (props && props.properties) {
      props.properties.forEach(function (prop) {
        if (prop.id == 2) {
          result = false;
        }
      });
    }
  });
  if (customerClass == 7) {
    result = true;
  }
  return result;
});
